// ============================================================================
// EL RECORRIDO ACABA EN NUTRICIÓN, NO DENTRO DE UNA COMIDA (Jesús, 29-09, vídeo en su
// cuenta: «te deja dentro de una comida y tiene que dejarte dentro de la parte de
// nutrición»).
//
// Las tres últimas paradas de Nutrición van dentro de «Lo hago yo» (la ventana de montar
// la comida, que el propio recorrido abre en «Créala tú»). Al pulsar «Listo» en «100 u 80»,
// o «Saltar» en cualquiera de ellas, el recorrido se quitaba y la ventana se quedaba
// abierta. Ahora, al terminar, el recorrido lo avisa y la ventana de la comida se cierra
// sola, como con «Cancelar»: el recorrido no mete ningún alimento (solo elige la categoría
// Huevos para enseñar el 80 y el 100), así que no hay nada a medias que perder.
//
// Va en un fichero aparte, sin driver.js, para que la ventana de la comida lo escuche sin
// cargar el recorrido entero.
// ============================================================================

export const EVENTO_FIN_DEL_RECORRIDO = 'recorrido-terminado';

//: Lo lanza el recorrido al terminar, con 'visto' (Listo) o 'saltado' (Saltar, tocar fuera).
export const avisarFinDelRecorrido = (estado) => {
    try {
        window.dispatchEvent(new CustomEvent(EVENTO_FIN_DEL_RECORRIDO, { detail: { estado } }));
    } catch (e) {
        console.error('No se pudo avisar del final del recorrido', e);
    }
};

//: Se apunta a ese aviso. Devuelve la función para desapuntarse (para el `return` de un efecto).
export const alTerminarElRecorrido = (hacer) => {
    const oir = (ev) => hacer(ev?.detail?.estado);
    window.addEventListener(EVENTO_FIN_DEL_RECORRIDO, oir);
    return () => window.removeEventListener(EVENTO_FIN_DEL_RECORRIDO, oir);
};
